import axios from 'axios';

const PLANT = process.env.REACT_APP_PLANT || 'BCAEX';

// In production, the client is served by the same Express app that hosts the
// API (single combined deployment), so a relative path is correct by default.
// Local dev runs the client (port 3000) and server (port 5000) separately.
const DEFAULT_API_URL = process.env.NODE_ENV === 'production' ? '/api/v1' : 'http://localhost:5000/api/v1';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || DEFAULT_API_URL,
});

// Attach the JWT and the trusted plant header to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bcaex_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Plant'] = PLANT;
  return config;
});

// On 401, drop the token and bounce to login.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401 && !err.config.url.includes('/auth/login')) {
      localStorage.removeItem('bcaex_token');
      localStorage.removeItem('bcaex_user');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Normalises axios errors into { message, status } for the UI.
export function apiError(err) {
  return {
    status: err.response?.status,
    message: err.response?.data?.error || err.message || 'Request failed',
  };
}

export { PLANT };
export default api;
